"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANGUAGE_DICTIONARY = exports.SHOW_MCMS_KEY_INDICATOR = exports.TAURUS_COOKIE_NAME = exports.COOKIE_NAME = exports.Language = void 0;
/**
 * 所有支持语言的枚举值
 */
var Language;
(function (Language) {
    /**
     * 简体中文
     */
    Language[Language["zh_CN"] = 0] = "zh_CN";
    /**
     * 繁体中文（台湾）
     */
    Language[Language["zh_TW"] = 1] = "zh_TW";
    /**
     * 繁体中文（香港）
     */
    Language[Language["zh_HK"] = 2] = "zh_HK";
    /**
     * 英文
     */
    Language[Language["en_US"] = 3] = "en_US";
    /**
     * 日文
     */
    Language[Language["ja_JP"] = 4] = "ja_JP";
    /**
     * 越南语
     */
    Language[Language["vi_VN"] = 5] = "vi_VN";
    /**
     * 泰语
     */
    Language[Language["th_TH"] = 6] = "th_TH";
    /**
     * 尼泊尔语
     */
    Language[Language["ne_NP"] = 7] = "ne_NP";
    /**
     * 印尼语
     */
    Language[Language["id_ID"] = 8] = "id_ID";
    /**
     * 马来语
     */
    Language[Language["ms_MY"] = 9] = "ms_MY";
    /**
     * 朝鲜语，韩语
     */
    Language[Language["ko_KR"] = 10] = "ko_KR";
    /**
     * 西班牙语
     */
    Language[Language["es_LA"] = 11] = "es_LA";
    /**
     * 法语
     */
    Language[Language["fr_FR"] = 12] = "fr_FR";
    /**
     * 俄语
     */
    Language[Language["ru_RU"] = 13] = "ru_RU";
    /**
     * 葡萄牙语
     */
    Language[Language["pt_BR"] = 14] = "pt_BR";
    /**
     * 土耳其语
     */
    Language[Language["tr_TR"] = 15] = "tr_TR";
})(Language = exports.Language || (exports.Language = {}));
exports.COOKIE_NAME = 'dd_l';
exports.TAURUS_COOKIE_NAME = 'SSO_LANG_V2'; // 专有钉cookie
exports.SHOW_MCMS_KEY_INDICATOR = 'ShowMcmsKey';
exports.LANGUAGE_DICTIONARY = {
    zh: Language.zh_CN,
    en: Language.en_US,
    zh_tw: Language.zh_TW,
    zh_hk: Language.zh_HK,
    zh_hant: Language.zh_TW,
    zh_hant_hk: Language.zh_HK,
    ja: Language.ja_JP,
    vi: Language.vi_VN,
    th: Language.th_TH,
    ne: Language.ne_NP,
    id: Language.id_ID,
    ms: Language.ms_MY,
    ko: Language.ko_KR,
    es: Language.es_LA,
    fr: Language.fr_FR,
    ru: Language.ru_RU,
    pt: Language.pt_BR,
    tr: Language.tr_TR,
};
//# sourceMappingURL=constants.js.map